module.exports = new __parcel__URL__("meeting-notes.b36f93e3.png").toString();